var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCaretDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9997 9.17C16.6097 8.78228 15.9797 8.78228 15.5897 9.17L11.9997 12.71L8.4597 9.17C8.06967 8.78228 7.43974 8.78228 7.0497 9.17C6.86039 9.35777 6.75391 9.61337 6.75391 9.88C6.75391 10.1466 6.86039 10.4022 7.0497 10.59L11.2897 14.83C11.4775 15.0193 11.7331 15.1258 11.9997 15.1258C12.2663 15.1258 12.5219 15.0193 12.7097 14.83L16.9997 10.59C17.189 10.4022 17.2955 10.1466 17.2955 9.88C17.2955 9.61337 17.189 9.35777 16.9997 9.17Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default ForwardRef;